var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PRODUCTS_RESET_ACTION_TYPE, PRODUCTS_CLEAN_LOOKUP_ACTION_TYPE, PRODUCTS_FETCH_START_ACTION_TYPE, PRODUCTS_FETCH_SUCCESS_ACTION_TYPE, PRODUCTS_GET_START_ACTION_TYPE, PRODUCTS_GET_SUCCESS_ACTION_TYPE, PRODUCTS_LOOKUP_START_ACTION_TYPE, PRODUCTS_LOOKUP_SUCCESS_ACTION_TYPE, PRODUCTS_CREATE_PRODUCT_BY_CODE_START_ACTION_TYPE, PRODUCTS_CREATE_PRODUCT_BY_CODE_SUCCESS_ACTION_TYPE, PRODUCTS_SAVE_START_ACTION_TYPE, PRODUCTS_SAVE_SUCCESS_ACTION_TYPE, PRODUCTS_DELETE_START_ACTION_TYPE, PRODUCTS_DELETE_SUCCESS_ACTION_TYPE, PRODUCTS_ERROR_ACTION_TYPE, } from "./ProductsActionsTypes";
import Axios from "axios";
import { convertToProduct, convertToLookupProduct } from "./ProductsConverter";
import { alertErrorHandler } from "@spike/notifications-action";
import { serialize } from "object-to-formdata";
import { showSuccess } from "@spike/notifications-action";
var productsUrl = "/products";
var productUrl = "/product";
export var fetchProductsThunk = function (apiClientWrapper) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(fetchStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(productsUrl, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(fetchSuccess(response.data.map(function (productDto) { return convertToProduct(productDto, apiClientWrapper.masterData, apiClientWrapper.marketplace); })));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_1 = _a.sent();
                    console.error({ apiError: apiError_1 });
                    if (!Axios.isCancel(apiError_1)) {
                        dispatch(error());
                        alertErrorHandler(apiError_1, dispatch, "Error fetching products.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getProductThunk = function (apiClientWrapper, productId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(productsUrl, "/").concat(productId, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getSuccess(convertToProduct(response.data, apiClientWrapper.masterData, apiClientWrapper.marketplace)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_2 = _a.sent();
                    if (!Axios.isCancel(apiError_2)) {
                        dispatch(error());
                        alertErrorHandler(apiError_2, dispatch, "Error getting product.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveProductThunk = function (apiClientWrapper, product) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, apiClientMethod, saveUrl, bodyRequest, formData, options, response, apiError_3;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        return __generator(this, function (_0) {
            switch (_0.label) {
                case 0:
                    dispatch(saveStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    apiClientMethod = product.id ? apiClientWrapper.apiClient.patch : apiClientWrapper.apiClient.post;
                    saveUrl = product.id
                        ? "".concat(productsUrl, "/").concat(product.id, "?marketplace_id=").concat(marketplaceId)
                        : "".concat(productsUrl, "?marketplace_id=").concat(marketplaceId);
                    bodyRequest = {
                        id: product.id,
                        uuid: product.uuid,
                        product_category_id: (_a = product.category) === null || _a === void 0 ? void 0 : _a.id,
                        unit_id: (_c = (_b = product.size) === null || _b === void 0 ? void 0 : _b.unit) === null || _c === void 0 ? void 0 : _c.id,
                        unit_amount: (_d = product.size) === null || _d === void 0 ? void 0 : _d.amount,
                        sku: product.sku,
                        name: product.name,
                        description: product.description,
                        brand: product.brand,
                        manofacturer: product.manufacturer,
                        barcode: product.code,
                        metadata: product.metadata,
                        alert: ((_e = product.businessProduct) === null || _e === void 0 ? void 0 : _e.alert) || 0,
                        price: product.price,
                        bestseller: product.bestseller,
                        created_from_scratch: product.createdFromScratch,
                        active: product.active,
                        business_products_attributes: [
                            {
                                id: (_f = product.businessProduct) === null || _f === void 0 ? void 0 : _f.id,
                                uuid: (_g = product.businessProduct) === null || _g === void 0 ? void 0 : _g.uuid,
                                marketplace_id: marketplaceId,
                                product_id: product.id,
                                name: (_h = product.businessProduct) === null || _h === void 0 ? void 0 : _h.name,
                                description: (_j = product.businessProduct) === null || _j === void 0 ? void 0 : _j.description,
                                barcode: (_k = product.businessProduct) === null || _k === void 0 ? void 0 : _k.code,
                                brand: (_l = product.businessProduct) === null || _l === void 0 ? void 0 : _l.brand,
                                manofacturer: (_m = product.businessProduct) === null || _m === void 0 ? void 0 : _m.manufacturer,
                                price: (_o = product.businessProduct) === null || _o === void 0 ? void 0 : _o.pricing.price,
                                stock: (_p = product.businessProduct) === null || _p === void 0 ? void 0 : _p.stock,
                                unit_id: (_s = (_r = (_q = product.businessProduct) === null || _q === void 0 ? void 0 : _q.size) === null || _r === void 0 ? void 0 : _r.unit) === null || _s === void 0 ? void 0 : _s.id,
                                unit_amount: ((_u = (_t = product.businessProduct) === null || _t === void 0 ? void 0 : _t.size) === null || _u === void 0 ? void 0 : _u.amount) || null,
                                available_for_checkout: (_v = product.businessProduct) === null || _v === void 0 ? void 0 : _v.availableForCheckout,
                                tax_ids: ((_x = (_w = product.businessProduct) === null || _w === void 0 ? void 0 : _w.pricing.taxes) === null || _x === void 0 ? void 0 : _x.map(function (tax) { return tax.id; })) || [],
                                image: ((_y = product.businessProduct) === null || _y === void 0 ? void 0 : _y.deleteImage) ? new Blob() : (_z = product.businessProduct) === null || _z === void 0 ? void 0 : _z.imageFile,
                            }
                        ],
                        sells_attributes: product.vendors.map(function (vendor) {
                            return {
                                id: vendor.id,
                                uuid: vendor.uuid,
                                marketplace_id: marketplaceId,
                                product_id: product.id,
                                vendor_id: vendor.vendor.id,
                                cost: vendor.cost,
                                default: vendor.default,
                            };
                        }),
                    };
                    formData = new FormData();
                    options = {
                        indices: false,
                        nullsAsUndefineds: false,
                        booleansAsIntegers: false,
                        allowEmptyArrays: true,
                    };
                    formData = serialize(bodyRequest, options, formData, "product");
                    _0.label = 1;
                case 1:
                    _0.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientMethod(saveUrl, formData, apiClientWrapper.multipartRequestConfig)];
                case 2:
                    response = _0.sent();
                    dispatch(saveSuccess(convertToProduct(response.data, apiClientWrapper.masterData, apiClientWrapper.marketplace)));
                    dispatch(fetchProductsThunk(apiClientWrapper));
                    dispatch(showSuccess("Product saved successfully"));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_3 = _0.sent();
                    if (!Axios.isCancel(apiError_3)) {
                        dispatch(error());
                        alertErrorHandler(apiError_3, dispatch, "Error saving product.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var deleteProductThunk = function (apiClientWrapper, product) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, apiError_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(deleteStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(productsUrl, "/").concat(product.id, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.delete(url, apiClientWrapper.requestConfig)];
                case 2:
                    _a.sent();
                    dispatch(deleteSuccess(product.uuid));
                    dispatch(showSuccess("Product deleted"));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_4 = _a.sent();
                    if (!Axios.isCancel(apiError_4)) {
                        dispatch(error());
                        alertErrorHandler(apiError_4, dispatch, "Error deleting product.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var createProductByCodeThunk = function (apiClientWrapper, code) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(createProductByCodeStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(productUrl, "/search_by_barcode/").concat(code, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, undefined, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(createProductByCodeSuccess(convertToProduct(response.data, apiClientWrapper.masterData, apiClientWrapper.marketplace)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_5 = _a.sent();
                    if (!Axios.isCancel(apiError_5)) {
                        dispatch(error());
                        alertErrorHandler(apiError_5, dispatch, "Error creating product by code.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var lookupThunk = function (apiClientWrapper, text) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(lookupStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(productUrl, "/search/").concat(text, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(lookupSuccess(convertToLookupProduct(response.data)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_6 = _a.sent();
                    if (!Axios.isCancel(apiError_6)) {
                        dispatch(error());
                        alertErrorHandler(apiError_6, dispatch, "Error looking up products.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var cleanLookupThunk = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(cleanLookup());
            return [2 /*return*/];
        });
    }); };
};
export var reset = function () {
    return {
        type: PRODUCTS_RESET_ACTION_TYPE,
    };
};
var fetchStart = function () {
    return {
        type: PRODUCTS_FETCH_START_ACTION_TYPE,
    };
};
var fetchSuccess = function (products) {
    return {
        type: PRODUCTS_FETCH_SUCCESS_ACTION_TYPE,
        payload: {
            products: products,
        },
    };
};
var createProductByCodeStart = function () {
    return {
        type: PRODUCTS_CREATE_PRODUCT_BY_CODE_START_ACTION_TYPE,
    };
};
var createProductByCodeSuccess = function (product) {
    return {
        type: PRODUCTS_CREATE_PRODUCT_BY_CODE_SUCCESS_ACTION_TYPE,
        payload: {
            product: product,
        },
    };
};
var lookupStart = function () {
    return {
        type: PRODUCTS_LOOKUP_START_ACTION_TYPE,
    };
};
var lookupSuccess = function (products) {
    return {
        type: PRODUCTS_LOOKUP_SUCCESS_ACTION_TYPE,
        payload: {
            products: products,
        },
    };
};
var getStart = function () {
    return {
        type: PRODUCTS_GET_START_ACTION_TYPE,
    };
};
var getSuccess = function (product) {
    return {
        type: PRODUCTS_GET_SUCCESS_ACTION_TYPE,
        payload: {
            product: product,
        },
    };
};
var saveStart = function () {
    return {
        type: PRODUCTS_SAVE_START_ACTION_TYPE,
    };
};
var saveSuccess = function (product) {
    return {
        type: PRODUCTS_SAVE_SUCCESS_ACTION_TYPE,
        payload: {
            product: product,
        },
    };
};
var deleteStart = function () {
    return {
        type: PRODUCTS_DELETE_START_ACTION_TYPE,
    };
};
var deleteSuccess = function (productUuid) {
    return {
        type: PRODUCTS_DELETE_SUCCESS_ACTION_TYPE,
        payload: {
            productUuid: productUuid,
        },
    };
};
var cleanLookup = function () {
    return {
        type: PRODUCTS_CLEAN_LOOKUP_ACTION_TYPE,
    };
};
var error = function () {
    return {
        type: PRODUCTS_ERROR_ACTION_TYPE,
    };
};
